import { useEffect } from "react";
import "./ToggleSwitch.css";

const ToggleSwitch = ({ isOn, setIsOn, onChange, name }) => {
  useEffect(() => {
    onChange({
      target: {
        name,
        value: isOn,
      },
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [isOn]);

  return (
    <div className="toggle-switch" onClick={() => setIsOn(!isOn)}>
      <div className={`toggle-slider ${isOn ? "on" : "off"}`}></div>
    </div>
  );
};

export default ToggleSwitch;
